// Firebase web config for asp-track. These values are PUBLIC by design (they
// identify the project to the client SDK); security is enforced by Firestore
// rules + Auth, never by hiding these. Not a secret.
export const firebaseConfig = {
  apiKey: 'AIzaSyBGdTYBfLxkRGk0Xs8M4iybF7fVcfiE7sY',
  // First-party auth handler (Karan 09/07): the sign-in helper runs on our OWN
  // domain, so it's same-site as the app — immune to Safari/Chrome cross-site
  // storage restrictions (Google's recommended setup for a custom domain).
  // Requires https://track.aspconsulting.co.uk/__/auth/handler in the OAuth
  // client's redirect URIs (added 09/07) + the domain in authorizedDomains.
  // Off ASP's address the sign-in helper runs on THAT address (every Firebase
  // Hosting domain serves /__/auth/handler), so it stays same-site there too
  // (wave 1, 22/10/2026). Each such address must be in Firebase's authorised
  // domains and the Google OAuth client's redirect URIs (Karan, console).
  // A preview channel (asp-track--<channel>.web.app) signs in through Firebase's
  // own handler, which is already on the Google client's list (read-only preview, 23/10/2026).
  authDomain: (typeof location !== 'undefined' && /--[a-z0-9-]+\.web\.app$/i.test(location.hostname)) ? 'asp-track.firebaseapp.com'
    : (typeof location !== 'undefined' && !['track.aspconsulting.co.uk', 'localhost', '127.0.0.1', '[::1]', '::1'].includes(location.hostname))
    ? location.host : 'track.aspconsulting.co.uk',
  projectId: 'asp-track',
  storageBucket: 'asp-track.firebasestorage.app',
  messagingSenderId: '685532380740',
  appId: '1:685532380740:web:7b800b75a3aebf551f8611',
};

// The organisation the signed-in person belongs to, read from their claim at
// sign-in (auth.js → setOrgId; multi-tenant step 3). Every path is built from
// it at CALL time (db.js col/orgPath), never captured at load. The initial value
// only stands before sign-in, when the rules let nothing be read.
export let ORG_ID = 'asp';
export function setOrgId(id) {
  if (typeof id === 'string' && /^[a-z0-9][a-z0-9_-]{1,39}$/.test(id)) ORG_ID = id;
  return ORG_ID;
}
export const ORG_DOMAIN = 'aspconsulting.co.uk';

// OAuth 2.0 Web client ID for per-user Gmail/Drive read-only access (Google
// Identity Services). Also PUBLIC by design — it identifies the app, not a
// secret. This is the Firebase auto-created Web client for asp-track; see
// dashboard/GOOGLE-SETUP.md for the consent-screen/origin requirements.
export const GOOGLE_OAUTH_CLIENT_ID =
  '685532380740-56kujr53d4o92kjd5jhl9924991rjpp4.apps.googleusercontent.com';
